import React from "react";
export default (function (_ref) {
  var isActive = _ref.isActive;
  return React.createElement("div", {
    style: {
      display: isActive ? "block" : "none",
      width: "100%",
      height: "100%",
      position: "absolute",
      top: 0,
      left: 0,
      backgroundColor: "#000",
      zIndex: 11
    }
  }, React.createElement("div", {
    className: "video-react-loading-spinner",
    style: {
      display: "block"
    }
  }));
});